import type { ReactNode } from "react";
import { Link } from "react-router";
import { PageContainer } from "@/app/layouts/PageContainer";

export interface ListPageProps {
  title: string;
  primaryAction?: ReactNode;
  filterBar?: ReactNode;
  children: ReactNode;
  backTo?: string;
}

export function ListPage({ title, primaryAction, filterBar, children, backTo }: ListPageProps) {
  return (
    <PageContainer>
      {backTo && (
        <Link to={backTo} className="mb-2 inline-block text-sm text-muted-foreground hover:underline">← Back</Link>
      )}
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {primaryAction}
      </div>
      {filterBar ? <div className="mb-4">{filterBar}</div> : null}
      {children}
    </PageContainer>
  );
}
